---
meta:
  - title: Ejecutar y leer resultados - IUSPRO Docs
  - description: Aprenda a ejecutar agentes, seguir su progreso y entender el resultado final.
---

# Ejecutar y leer resultados

Cuando ejecuta un agente, usted entrega la información del asunto y el sistema hace el trabajo en segundo plano.

## Qué puede adjuntar al ejecutar

Además de la información principal, puede adjuntar:

- un expediente
- un cliente
- redacciones existentes

Eso sirve para dar más contexto al trabajo cuando el caso lo necesita.

## Qué pasa después de iniciar

La ejecución puede pasar por estos estados:

- pendiente
- en progreso
- completada
- fallida
- cancelada

No necesita quedarse esperando en la pantalla. Puede volver después.

## Cómo leer el resultado

En el detalle verá:

- el estado general
- las distintas partes del trabajo
- el resultado de cada una
- el resultado final

## Si el agente termina en Redactor

El resultado final queda en un documento real del Redactor.

Desde ahí puede:

- seguir editando
- exportar
- continuar la conversación en el chat del documento

## Si no termina en Redactor

Puede continuar el resultado final en Auri.

Eso sirve para:

- hacer preguntas
- pedir ajustes
- profundizar un punto
- convertir la respuesta en otra cosa

## Datos de depuración

Cada parte del agente tiene una sección de depuración.

Eso le sirve para ver:

- qué instrucción se usó
- qué información recibió esa parte
- qué salió
- si hubo reintentos
- errores, fuentes o enlaces cuando corresponda

No hace falta abrir esto siempre. Úselo cuando quiera entender por qué salió algo de cierta manera.

## Si una ejecución falla

La ejecución conserva historial.

Además, puede reintentar la parte fallida sin volver a empezar todo desde cero.

## Siguiente lectura

- Lea [compartir y publicar agentes](/guias/agentes-compartir-y-publicar)
- Lea [buenas prácticas](/guias/agentes-buenas-practicas)
